import React from 'react';
import { Typography, Box } from '@mui/material';
import useOrgStore from '../store/zustand/useOrgStore';

export default function OrgUserIndicator() {
  const orgData = useOrgStore((state) => state.orgData);
  // @ts-ignore
  const me = (global as any)?.me;

  const orgName = orgData?.name || '';
  const userEmail = me?.email || me?.name || '';

  if (!orgName && !userEmail) {
    return null;
  }

  return (
    <Box
      sx={{
        textAlign: 'center',
        pb: 0.5,
      }}
    >
      {orgName && (
        <Typography
          sx={(theme) => ({
            fontSize: 12,
            fontWeight: 600,
            color: theme.custom?.textLight,
            '.dark &': { color: 'hsl(0 0% 65%)' },
          })}
        >
          Org: {orgName}
        </Typography>
      )}
      {userEmail && (
        <Typography
          sx={(theme) => ({
            fontSize: 12,
            color: theme.custom?.textLight,
            '.dark &': { color: 'hsl(0 0% 65%)' },
          })}
        >
          User: {userEmail}
        </Typography>
      )}
    </Box>
  );
}
